export default __webpack_public_path__ + "static/media/368a1e82-428e-4a89-b49b-9475bfce6041.4d37585f.ttf";